import customFetchBase from "../../../principal/customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";

export const antecedentesApi = createApi({
  reducerPath: "antecedentesApi",
  baseQuery: customFetchBase,
  tagTypes: ["Antecedentes"],
  endpoints: () => ({}),
});
